import makeCrud from '@/store/site/localization/crud'

// Satış kanalı tanımlama CRUD'u (name/sort/active) — ortak CRUD store fabrikası yeterli.
export default makeCrud('ecommerce_sales_channel')
